import { definitions } from "../../common-fetch/generated/orders-model-api";
import { cartFlowSequence } from "./cartFlowSequence";
import { groupErrorToPage } from "./groupErrorToPage";

type BuildFurthestContinueIndexOptions = {
  readonly peekWithinErrorGroup?: true;
};

export function buildFurthestContinueIndex(
  input: definitions["OrderError"],
  options?: BuildFurthestContinueIndexOptions
) {
  return function furthestContinueIndex() {
    const index = cartFlowSequence.findIndex((item, itemIndex) => {
      const isFirstErrorGroupMatch =
        item.errorPage === groupErrorToPage(input.errorGroup);
      const isNextErrorGroupMatch =
        cartFlowSequence[itemIndex + 1]?.errorPage ===
        groupErrorToPage(input.errorGroup);

      return options?.peekWithinErrorGroup
        ? isFirstErrorGroupMatch && !isNextErrorGroupMatch
        : isFirstErrorGroupMatch;
    });

    return index < 0 ? cartFlowSequence.length - 1 : index;
  };
}
